module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/componentes/layout/header.component.scss
// module id = ./src/app/componentes/layout/header.component.scss
// module chunks = main